/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DocumentFromJSON(json) {
    return DocumentFromJSONTyped(json, false);
}
export function DocumentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'pmScheduleId': !exists(json, 'pmScheduleId') ? undefined : json['pmScheduleId'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'partId': !exists(json, 'partId') ? undefined : json['partId'],
        'costId': !exists(json, 'costId') ? undefined : json['costId'],
        'procedureId': !exists(json, 'procedureId') ? undefined : json['procedureId'],
        'docType': !exists(json, 'docType') ? undefined : json['docType'],
        'docCategory': !exists(json, 'docCategory') ? undefined : json['docCategory'],
        'docTitle': !exists(json, 'docTitle') ? undefined : json['docTitle'],
        'docDescription': !exists(json, 'docDescription') ? undefined : json['docDescription'],
        'docStatus': !exists(json, 'docStatus') ? undefined : json['docStatus'],
        'docStatusDate': !exists(json, 'docStatusDate') ? undefined : (new Date(json['docStatusDate'])),
        'containerData': !exists(json, 'containerData') ? undefined : json['containerData'],
        'containerFileName': !exists(json, 'containerFileName') ? undefined : json['containerFileName'],
        'nextVersionNumber': !exists(json, 'nextVersionNumber') ? undefined : json['nextVersionNumber'],
        'currentVersion': !exists(json, 'currentVersion') ? undefined : json['currentVersion'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDateTime': !exists(json, 'createdDateTime') ? undefined : (new Date(json['createdDateTime'])),
        'modifiedDateTime': !exists(json, 'modifiedDateTime') ? undefined : (new Date(json['modifiedDateTime'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}
export function DocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'documentId': value.documentId,
        'propertyId': value.propertyId,
        'workorderId': value.workorderId,
        'pmScheduleId': value.pmScheduleId,
        'assetId': value.assetId,
        'partId': value.partId,
        'costId': value.costId,
        'procedureId': value.procedureId,
        'docType': value.docType,
        'docCategory': value.docCategory,
        'docTitle': value.docTitle,
        'docDescription': value.docDescription,
        'docStatus': value.docStatus,
        'docStatusDate': value.docStatusDate === undefined ? undefined : (value.docStatusDate.toISOString()),
        'containerData': value.containerData,
        'containerFileName': value.containerFileName,
        'nextVersionNumber': value.nextVersionNumber,
        'currentVersion': value.currentVersion,
        'createdBy': value.createdBy,
        'createdDateTime': value.createdDateTime === undefined ? undefined : (value.createdDateTime.toISOString()),
        'modifiedDateTime': value.modifiedDateTime === undefined ? undefined : (value.modifiedDateTime.toISOString()),
        'modifiedBy': value.modifiedBy,
    };
}
